module.exports = __webpack_public_path__ + "static/media/clemente_castor_9.21dae35c.jpg";